import { useEffect } from 'react';

export default function PageTitle({ children }) {
  useEffect(() => {
    document.title = String(children || '').replaceAll(',', '');
  }, [children]);

  return null;
}
